import React from 'react';
import Preview from '../previews/Name';

const NameQuestion = ({}) => {
  return <></>;
};

NameQuestion.StepsCount = 2;
NameQuestion.Preview = Preview;
NameQuestion.StepDescription = '';

export default NameQuestion;
